export function storeStaticPaths(param) {
    var links = param.links;
    var paths = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(links)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var linkKey = _step.value;
            if (links[linkKey].is_folder) {
                continue;
            }
            var slug = links[linkKey].slug.split("/")[1];
            paths.push({
                params: {
                    slug: slug
                }
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return paths;
}
export var generateFallbackTitle = function(storeName) {
    return "cinch store ".concat(storeName, " | Buy used cars in ").concat(storeName);
};
export var generateFallbackDescription = function(storeName) {
    return "Welcome to the cinch store in ".concat(storeName, ", offering used cars, part exchange & car viewing. Visit the cinch store ").concat(storeName, " for faff-free car buying.");
};
